import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Package } from '@models/package';
import { ClinicServiceTemplate } from '@models/service/clinic-service-template';
import { Service } from '@models/service/service';
import { PlannedTreatmentMultiple } from '@models/treatment-planning/planned-treatment-multiple';

@Injectable()
export class PackagesService {
  constructor(private http: HttpClient) {}

  getPackages() {
    return this.http.get<Package[]>(environment.baseUrl + 'api/Packages');
  }

  getPackage(packageId: number) {
    return this.http.get<Package>(environment.baseUrl + 'api/Packages/' + packageId);
  }

  addPackage(pkg: Package) {
    return this.http.post<Package>(environment.baseUrl + 'api/Packages', pkg);
  }

  updatePackage(pkg: Package) {
    return this.http.put<void>(environment.baseUrl + 'api/Packages', pkg);
  }

  removePackage(pkgId: Number) {
    return this.http.delete(environment.baseUrl + 'api/Packages/' + pkgId);
  }

  static convertToMultiple(
    pkg: Package,
    service: Service,
    serviceTemplate: ClinicServiceTemplate,
    patientId: number,
    treatmentPlanId: number
  ): PlannedTreatmentMultiple {
    return new PlannedTreatmentMultiple({
      patientId: patientId,
      treatmentPlanId: treatmentPlanId,
      serviceTemplateId: serviceTemplate.id,
      createdFromPackageId: pkg.id,
      service: service,
      price: serviceTemplate.defaultPrice,
      quantity: pkg.quantity,
      totalAmount: pkg.price ?? serviceTemplate.defaultPrice * pkg.quantity,
      notes: pkg.note
    });
  }
}
